export var WalletAdapterNetwork;
(function (WalletAdapterNetwork) {
    WalletAdapterNetwork["Testnet"] = "testnet3";
})(WalletAdapterNetwork || (WalletAdapterNetwork = {}));
;
export var DecryptPermission;
(function (DecryptPermission) {
    DecryptPermission["NoDecrypt"] = "NO_DECRYPT";
    DecryptPermission["UponRequest"] = "DECRYPT_UPON_REQUEST";
    DecryptPermission["AutoDecrypt"] = "AUTO_DECRYPT";
    DecryptPermission["ViewKeyAccess"] = "VIEW_KEY_ACCESS"; // The App gets the View Key of the connected wallet
})(DecryptPermission || (DecryptPermission = {}));
//# sourceMappingURL=types.js.map